import { render, staticRenderFns } from "./MicrositeBackgroundManager.vue?vue&type=template&id=05530904&scoped=true&"
import script from "./MicrositeBackgroundManager.vue?vue&type=script&lang=ts&"
export * from "./MicrositeBackgroundManager.vue?vue&type=script&lang=ts&"
import style0 from "./MicrositeBackgroundManager.vue?vue&type=style&index=0&id=05530904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05530904",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VColorPicker,VDialog,VIcon})
